import React from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core'

import DoorAccessUserAutosuggest from './DoorAccessUserAutosuggest'

class UnitGrantDoorAccessDialog extends React.Component {
  static propTypes = {
    doorAccesses: PropTypes.array.isRequired,
    isFormValid: PropTypes.bool.isRequired,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onSuggestionSelected: PropTypes.func.isRequired,
    submitButtonLabel: PropTypes.string.isRequired,
    unitName: PropTypes.string.isRequired,
  }

  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.onClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          Add a User to Unit {this.props.unitName}
        </DialogTitle>
        <DialogContent>
          <DoorAccessUserAutosuggest
            doorAccesses={this.props.doorAccesses}
            onSelect={this.props.onSuggestionSelected}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onClose}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={this.props.onSubmit}
            disabled={!this.props.isFormValid}
          >
            {this.props.submitButtonLabel}
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default UnitGrantDoorAccessDialog
